// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3F49a","noInteraction":"EventWrapper_noInteraction__1Y7pf"};